
export default function cardShowInit(coreHandler){
  [...document.querySelectorAll(".js__megamenu-btn")].forEach(v => {

    v.addEventListener("click", function(e){
      if(e.target.classList.contains("is-show")){
        e.target.classList.remove("is-show");
        e.target.nextElementSibling.classList.remove("is-show");
        // gsap.to( e.target.nextElementSibling, { height: auto , ease: "power1.out" , duration: 1});
      }else{
        e.target.classList.add("is-show");
        e.target.nextElementSibling.classList.add("is-show");
        // gsap.to( e.target.nextElementSibling, { height: 250 + "px" , ease: "power1.out" , duration: 1});
      }
      coreHandler.followBannerReflesh();
    });

  });
}